// removed by extract-text-webpack-plugin
module.exports = {"txt-para":"txt-para__DZGdj","box-3":"box-3__rWsdX","box-2-txt":"box-2-txt__1NpbD","pad90":"pad90__3jhuH","line-bottom":"line-bottom__1YKSR","graph-img":"graph-img__1R9xE"};


//////////////////
// WEBPACK FOOTER
// ./styles/elss/elssvsother.scss
// module id = 1262
// module chunks = 68